import React from 'react'
import s from './index.module.scss'
import classNames from 'classnames'

const statuses = {
	new: 'Новий',
	confirmed: 'Підтверджений',
	rejected: 'Відхилений',
	canceled: 'Скасований',
	paid: 'Оплачений',
	completed: 'Завершений',
}

type Statuses = typeof statuses

type Status = {
	name: string
	text: string
	color: string
}

interface IProps {
	type: Status | boolean | keyof Statuses
}

const Status: React.FC<IProps> = ({ type }) => {
	const Text = () => {
		if (typeof type === 'boolean') {
			return <>{type ? 'Активний' : 'Заблокований'}</>
		}
		if (typeof type === 'string' && statuses.hasOwnProperty(type)) {
			return <>{statuses[type]}</>
		}
		if (typeof type === 'object') {
			return <>{type.text}</>
		}
		return <></>
	}

	return (
		<div
			className={classNames(s.status, {
				[s.blocked]: !type || type === 'rejected' || type === 'canceled',
			})}
			style={{
				...(typeof type === 'object' && {
					color: type.color,
					borderColor: type.color,
				}),
			}}
		>
			<Text />
		</div>
	)
}

export default Status
